// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607091028/js/" + chunkId + "." + {"44":"4003e4d4","225":"c780c64d","481":"07a30c4d","486":"60e3e782","770":"ff56e04a"}[chunkId] + ".0.11268388798169515.chunk.js";
};